/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum Instroom {
    INTERN = "Intern",
    INTERN_TUSSENTIJDS = "Intern (tussentijds)",
    EXTERN = "Extern",
    EXTERN_TUSSENTIJDS = "Extern (tussentijds)"
}
